import { ChangeDetectionStrategy, Component, computed, inject, input, model } from '@angular/core';
import { SoundName } from '@dev-fast/types';

import { getStaticUrl } from '@app/shared/utils/static-url';

import { AprilMadnessSoundsService } from '../../../services/april-madness-sounds.service';
import type { IEventLevel } from '../../../types/frontend/event-level.interface';

const APRIL_MADNESS_CARD_FRAME_BACKGROUND_IMAGE = `url('${getStaticUrl('/aprilmadness/shared/card-frame.png')}')`;

@Component({
  selector: 'app-holo-card',
  templateUrl: './holo-card.component.html',
  styleUrl: './holo-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HoloCardComponent {
  readonly #aprilMadnessSoundsService = inject(AprilMadnessSoundsService);

  readonly level = input<IEventLevel>();
  readonly disableHoverFlip = input<boolean>(false);
  readonly isFlipped = model<boolean>(false);
  readonly type = computed(() => this.level()?.item?.type);
  readonly isAgent = computed(() => this.type() === 'agent');
  readonly image = computed(() => this.level()?.item?.image);
  readonly exterior = computed(() => this.level()?.item?.exterior);
  readonly shortName = computed(() => this.level()?.item?.shortName);
  readonly skin = computed(() => this.level()?.item?.skin);
  readonly frameBackgroundImage = APRIL_MADNESS_CARD_FRAME_BACKGROUND_IMAGE;

  readonly caseImage = computed<string>(() => this.level()?.case?.image ?? '');

  onMouseEnter(): void {
    if (!this.disableHoverFlip()) {
      this.#aprilMadnessSoundsService.playSoundThrottled(SoundName.ICE_BREAKER_OPEN_THE_PACK_SMALL_TURN_CARD_A, true);
      this.isFlipped.set(true);
    }
  }

  onMouseLeave(): void {
    if (!this.disableHoverFlip()) {
      this.#aprilMadnessSoundsService.playSoundThrottled(SoundName.ICE_BREAKER_OPEN_THE_PACK_SMALL_TURN_CARD_BACK, true);
      this.isFlipped.set(false);
    }
  }
}
